import moment from 'utils/app-moment';

const getWorkdeskReceivedTimeText = (receivedTime): string => {
  const receivedTimeM = moment(receivedTime);
  if (!receivedTimeM.isValid) return '-';
  const nowM = moment();
  if (receivedTimeM.isSame(nowM, 'd')) {
    return receivedTimeM.format('hh:mm A');
  } else if (receivedTimeM.isSame(nowM, 'y')) {
    return receivedTimeM.format('MMM DD');
  } else {
    return receivedTimeM.format('YYYY-MM-DD');
  }
};

const getAutoSavedTimeText = (updateDate): string => {
  const updateDateM = moment(updateDate);
  if (!updateDateM.isValid) return '-';
  const nowM = moment();
  if (updateDateM.isSame(nowM, 'd')) {
    return updateDateM.format('[at] hh:mm A');
  } else if (updateDateM.isSame(nowM, 'y')) {
    return updateDateM.calendar();
  } else {
    return updateDateM.format('YYYY-MM-DD');
  }
};

const getWorkdeskReceivedTimeHoverText = (
  receivedTime,
): null | string => {
  const receivedTimeM = moment(receivedTime);
  if (!receivedTimeM.isValid) return null;
  const nowM = moment();
  if (receivedTimeM.isSame(nowM, 'd')) {
    return null;
  } else {
    return receivedTimeM.format('hh:mm A');
  }
};

export const timeFormatters = {
  getWorkdeskReceivedTimeText,
  getWorkdeskReceivedTimeHoverText,
  getAutoSavedTimeText,
};
